<template>
<div>
  <div class="vx-row">

   

    <!-- MULTIPLE COLUMNS-->
    <div class="vx-col w-full mb-base">
      <vx-card title="">
        <div class="vx-row">
          <div class="vx-col sm:w-1/4 w-full mb-1"><v-select :value="program" v-model="program" :options="formatOptions"></v-select></div>
          <div class="vx-col sm:w-1/4 w-full mb-1"><vs-button color="success" @click="satisListesi()" type="filled">Listele</vs-button></div>
        </div>

          
       
  

      </vx-card>

      <vs-table :data="data">
        <template slot="thead">
          
          <vs-th>Stok Kodu</vs-th>
          <vs-th>Stok Adı</vs-th>
          <vs-th>Satış Adet</vs-th>
         
        
        </template>

          <template slot-scope="{data}">
            <vs-tr state="" :key="indextr" v-for="(tr, indextr) in data">
              
              <vs-td>
                 {{ data[indextr].stokKodu }}
              </vs-td>
              
              <vs-td>
               {{ data[indextr].productName }}
              </vs-td>
           <vs-td>
               {{ data[indextr].satisAdet }}
              </vs-td>
            
            </vs-tr>
            <vs-tr>
              <vs-td></vs-td>
              <vs-td>Toplam</vs-td>
              <vs-td>{{toplama()}}</vs-td>
            </vs-tr>
          </template>

      </vs-table>

    </div>

    
  </div>



  </div>
</template>



<script>
import vSelect from 'vue-select'
import Datepicker from 'vuejs-datepicker'
import state from '../../store/state'
import Store from '../../store/store'
export default{
  data () {
    return {
      format: "yyyy-MM-dd",
      data:[],
      baslangic: '',
      formattedDate: '',
      formattedDate1: '',
      bitis: '',
      program: {id: 0, label: 'Pazaryeri'},
      check3: '',
      formatOptions: [
        {label: "Ticimax", id:"Ticimax"},
        {label: "Trendyol", id:"Trendyol"},
        {label: "Hepsiburada", id:"Hepsiburada"},
        {label: "N11", id:"N11"},
      ],
    }
  },methods:{
     toplama() {
      var vm=this
      var sayi=0
      this.data.forEach(element => {
        sayi=sayi+parseInt(element.satisAdet)
      });
      return sayi
     // this.toplam=parseInt(this.toplam)+parseInt(d)
     // return this.toplam
      //console.log(this.toplam)
    },
satisListesi() {
         var vm = this

        const soap = require('soap')
        const url = state.sistemAddress
    
     // console.log(vm.formattedDate)
      if (this.program.label=='Pazaryeri') {
       this.program.label="'Ticimax','Trendyol','Hepsiburada','N11'";
     } else {
       this.program.label="'"+this.program.label+"'";
     }
      const args = {program:this.program.label,baslik:'stokRaporuBekleyen',tarih1:vm.formattedDate,tarih2:vm.formattedDate1,token:Store.state.tokenId,kullaniciId:'',siparisNo:''}
     // console.log(args)
      soap.createClient(url, function(err, client){
      client.standartSorguRapor(args, function(err, result){
        if (result.standartSorguRaporResult=='-1') {
          Store.dispatch('logout')
        }
        vm.veriler=JSON.parse(result.standartSorguRaporResult)
       // console.log(vm.veriler)
        vm.data=vm.veriler
       // vm.eslesenStokListesi=vm.veriler
        
  
      
      
        
      })
      })
    },
  },
   components: {
    'v-select': vSelect,
    Datepicker
  }
}
</script>
